import { useEffect } from "react";
import "./callToAction.scss";
import calLeft from "../../assets/images/cal-left.jpg";
import calRight from "../../assets/images/cal-right.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

export default function CallToAction() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);
  useEffect(() => {
    const callToActionElement = document.getElementById("calltoaction");

    if (callToActionElement) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            // Add 'active' class when element is in view
            callToActionElement.classList.add("active");
          } else {
            // Remove 'active' class when element is out of view
            callToActionElement.classList.remove("active");
          }
        },
        {
          rootMargin: "-100px 0px 0px 0px", // Set the offset (top margin)
        }
      );

      // Start observing the calltoaction element
      observer.observe(callToActionElement);

      // Clean up observer on component unmount
      return () => {
        observer.unobserve(callToActionElement);
      };
    }
  }, []);

  return (
    <div className="call_wrapper" id="calltoaction">
      <img className="cal-left" src={calLeft} alt="calLeft" />
      <div className="container">
        <h2 data-aos="zoom-in" data-aos-offset="500" data-aos-delay="100">
          Elevating your journey, we offer a variety of different cruise options meant to cater to even the finest of tastes.
        </h2>
      </div>
      <img className="cal-right" src={calRight} alt="calright" />
    </div>
  );
}
